import { NAVIGATION } from '../nav/types';
import { SET_ENV } from './types';
const initialState = {
  cid: '',
  redirect_uri: '',
  country: 'US',
  app: 'insulet',
  pId: ''
};
export const envReducer = (state = initialState, action) => {
  switch (action.type) {
    case NAVIGATION:
      return {
        ...state,
        app: action.context.query?.app || state.app,
        country: action.context.query?.country?.toUpperCase() || state.country,
        redirect_uri: action.context.query?.redirect_uri || state.redirect_uri,
        registration_return_uri: action.context.query?.registration_return_uri || state.registration_return_uri,
        cid: action.context.query?.cid || state.cid,
        pId: action.context.query?.pId || state.pId
      };
    case SET_ENV:
      return {
        ...state,
        ...action.env
      };
    default:
      return state;
  }
};